import React from 'react';
import './row-info-footer.css'


const Rowfooter = (props) => {
    return ( 
                <nav className='row-list2-footer'>
                    <img className='icons-footer' src={props.img} alt='icon'></img>
                    <h3 className='info-list2-footer'>{props.title}</h3>
                </nav>
     );
}
 
export default Rowfooter;